// extracted by mini-css-extract-plugin
export default {"flexContainer":"Assistant_flexContainer__+1zYr","textDiv":"Assistant_textDiv__9QUNZ"};